import React from 'react';
import {
  WorkspaceItemsContainer,
  WorkspaceItemsTitle,
  WorkspaceItemsList,
  WorkspaceItemRow,
  WorkspaceItemInfo,
  WorkspaceItemActions
} from './Items.styled';

const Items = () => {
  return (
    <WorkspaceItemsContainer>
      <WorkspaceItemsTitle>Items</WorkspaceItemsTitle>
      <WorkspaceItemsList>
        <WorkspaceItemRow>
          <WorkspaceItemInfo>
            {/* Workspace items will go here */}
          </WorkspaceItemInfo>
          <WorkspaceItemActions>
            {/* Actions will go here */}
          </WorkspaceItemActions>
        </WorkspaceItemRow>
      </WorkspaceItemsList>
    </WorkspaceItemsContainer>
  );
};

export default Items;
